// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"547":"e3219365","677":"fb95c828","813":"d2603c0d","941":"fc81b2f9"}[chunkId] + ".chunk.css";
};